<template>
  <div
    ref="ContentBoxBarChartAsset"
    data-test-id="block-wrapper"
    class="
      flex
      items-center
      lg:w-9/12
      md:w-6/12
      mx-auto
      h-full
      transition
      duration-500
      ease-in-out-quart
      select-none
      pointer-events-none
    "
    :class="[{ 'opacity-0': !isLoaded }]"
  >
    <div class="grid gap-y-2 w-full">
      <div
        v-for="(data, index) in values"
        :key="index"
        data-test-id="block-bar"
        class="bar relative h-10 rounded-r-full overflow-hidden"
        :class="{
          'flex items-center': numberedList,
          fullBgClass: !numberedList,
        }"
      >
        <span
          v-if="numberedList"
          class="
            font-druk
            tracking-02-em
            text-display-7
            leading-7
            md:text-display-7
            md:leading-7
            text-left
            uppercase
            shrink-0
            w-6
          "
        >
          {{ index + 1 }}.
        </span>
        <div
          class="
            bar-filled
            h-10
            float-left
            rounded-r-full
            w-full
            transform
            transition
            duration-800
            ease-in-out-quart
            delay-75
          "
          :class="[
            currentBgClass,
            { '-translate-x-full': !isLoaded },
            { 'mr-15': !numberedList },
            { 'mr-10': numberedList },
          ]"
          :style="`max-width:${(data.current * 100) / data.full}%`"
        />
        <div
          class="absolute inset-y-0 flex flex-col justify-center"
          :class="{
            'left-9': numberedList,
            'left-4': !numberedList,
          }"
        >
          <span
            class="font-gt-america-extended font-normal text-tiny"
            :class="[
              'labelTextClass || textClass',
              {
                uppercase: numberedList,
              },
            ]"
            data-test-id="text-label"
          >
            {{ data.label }}
          </span>
        </div>
        <div
          class="right-4 inset-y-0 flex flex-col justify-center"
          :class="{
            'relative justify-self-end ml-auto': numberedList,
            absolute: !numberedList,
          }"
        >
          <span
            class="font-gt-america-extended font-normal text-tiny"
            :class="[
              valueTextClass || textClass,
              { 'text-right leading-3': numberedList },
            ]"
            data-test-id="text-value"
          >
            {{ data.value }}
            <template v-if="numberedList">
              <br>
              <span class="uppercase">votes</span>
            </template>
          </span>
        </div>
      </div>
      <div v-if="disclaimer" class="text-infra-violette font-light text-tiny">
        <span data-test-id="text-disclaimer"> *{{ disclaimer }} </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentBoxBarChartAsset',
  props: {
    values: {
      type: Array,
      required: true
    },
    disclaimer: {
      type: String,
      default: () => null
    },
    currentBgClass: {
      type: String,
      default: () => 'bg-infra-violette'
    },
    fullBgClass: {
      type: String,
      default: () => 'bg-light-purple'
    },
    labelTextClass: {
      type: String,
      default: () => null
    },
    valueTextClass: {
      type: String,
      default: () => null
    },
    textClass: {
      type: String,
      default: () => 'text-dark'
    },
    numberedList: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data () {
    return {
      isLoaded: false
    }
  },
  mounted () {
    this.useIntersectionObserverToShowContent()
  },
  methods: {
    useIntersectionObserverToShowContent () {
      try {
        const observer = new IntersectionObserver(this.showContentCallback, {
          threshold: 0.2
        })
        observer.observe(this.$refs.ContentBoxBarChartAsset)
      } catch (error) {
        this.isLoaded = true
      }
    },
    showContentCallback (entries, observer) {
      if (!this.isLoaded) {
        const [entry] = entries
        if (entry && entry.isIntersecting) {
          this.isLoaded = true
        }
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
</style>
